import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';

import { modalConfirmationTicketStyles } from './styles';
import Buttons from '../../../mis-datos/components/common/Buttons';

import {
  closeModalConfirmationTicket,
  confirmationTicket,
} from '../../../../../redux/actions/TicketActions';
import ModalDispatchDate from './forms/changeDispatchDate/ModalDispatchDate';

const ModalConfirmationTicket = (props) => {
  const { mobile } = props;
  const classes = modalConfirmationTicketStyles({ mobile });
  const dispatch = useDispatch();
  const { openModalConfirmationTicket, modalInformation } = useSelector(
    (state) => state.ticketReducer,
  );

  const handleClose = () => {
    dispatch(closeModalConfirmationTicket());
  };

  const handleConfirmationTicket = () => {
    dispatch(confirmationTicket());
  };

  const getTitle = {
    1: 'Confirmar fecha',
  };

  const getChildren = {
    1: <ModalDispatchDate info={modalInformation} />,
  };

  return (
    <React.Fragment>
      <div className={classes.container}>
        <Dialog
          onClose={handleClose}
          open={openModalConfirmationTicket}
          maxWidth={'lg'}
          disableBackdropClick
          disableEscapeKeyDown
          classes={{
            paper: classes.paper,
          }}
        >
          <DialogTitle onClose={handleClose}>
            <Typography className={classes.title}>
              {getTitle[modalInformation.motiveId]}
            </Typography>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className={classes.normalText} dividers>
            {getChildren[modalInformation.motiveId]}
          </DialogContent>
          <DialogActions>
            <div className={classes.buttonsContainer}>
              <Buttons
                modifiable={true}
                onCancelClick={handleClose}
                onSendClick={handleConfirmationTicket}
                mobile={mobile}
                primaryButtonText={'Confirmar'}
                secondaryButtonText={'Cancelar'}
                marginRightButton={mobile ? 0 : 20}
                marginTop={15}
              />
            </div>
          </DialogActions>
        </Dialog>
      </div>
    </React.Fragment>
  );
};

ModalConfirmationTicket.propTypes = {
  mobile: PropTypes.bool,
};

export default ModalConfirmationTicket;
